export const MIN_PROPERTY_VALUE = 240000;
export const MAX_PROPERTY_VALUE = 99999999;
export const MIN_LOAN_AMOUNT = 100000;
export const MAX_LOAN_AMOUNT = 99999999;
